@if ((withoutLayoutYn$ | async) === true) {
  <router-outlet></router-outlet>
} @else if ((withoutLayoutYn$ | async) === false) {
  <app-layout>
    <router-outlet></router-outlet>
  </app-layout>
}
